import { Star } from "lucide-react";

const MAPS_LISTING =
  "https://www.google.com/maps/place/The+forest/@26.7173211,88.7670645,19z/data=!4m6!3m5!1s0x39e4750067f95f4b:0x75682f3016bf1f50!8m2!3d26.7173208!4d88.7676731!16s%2Fg%2F11m63lm5vj";

const Stars = ({ count = 5 }) => (
  <span className="flex gap-0.5">
    {Array.from({ length: count }).map((_, i) => (
      <Star key={i} size={14} className="text-[#C5A880]" fill="#C5A880" strokeWidth={0} />
    ))}
  </span>
);

const REVIEWS = [
  {
    text: "A very calm and warm setting. The staff is pleasant and the rooms are clean.",
    author: "Adv. Subhojit Chakraborty",
    stars: 5,
    note: "Google review · translated by Google",
  },
  {
    text: "Good",
    author: "Sabita Thulung Rai",
    stars: 5,
    note: "Google review",
  },
  {
    text: null,
    author: "Radhika Toppo",
    stars: 5,
    note: "Google review · rated without a written review",
  },
];

export const Reviews = () => {
  return (
    <section id="reviews" data-testid="reviews-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl">
          <p className="text-xs uppercase tracking-[0.3em] font-semibold text-[#C5A880]">Guest Words</p>
          <h2 className="font-serif-display font-light text-3xl md:text-4xl lg:text-5xl tracking-tight text-[#0B3B39] mt-4 leading-tight">
            What stays with them.
          </h2>
          <a
            href={MAPS_LISTING}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="google-rating-badge"
            className="inline-flex items-center gap-3 mt-6 bg-white border border-[#E6E2D8] px-5 py-3 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:border-[#C5A880] transition-colors duration-300"
          >
            <span className="font-serif-display text-2xl text-[#0B3B39]">4.7</span>
            <span className="flex flex-col items-start gap-1">
              <Stars count={5} />
              <span className="text-[10px] uppercase tracking-widest text-[#4A5568]">3 reviews on Google</span>
            </span>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-14">
          {REVIEWS.map((r, i) => (
            <figure
              key={i}
              data-testid={`review-card-${i}`}
              className="bg-white border border-[#E6E2D8] p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] flex flex-col"
            >
              <Stars count={r.stars} />
              {r.text ? (
                <blockquote className="font-serif-display text-xl leading-relaxed text-[#0B3B39] mt-5 flex-1">
                  “{r.text}”
                </blockquote>
              ) : (
                <blockquote className="font-serif-display text-xl leading-relaxed text-[#4A5568] italic mt-5 flex-1">
                  Rated us {r.stars} out of 5 stars.
                </blockquote>
              )}
              <figcaption className="mt-6">
                <span className="text-xs uppercase tracking-[0.2em] font-semibold text-[#0B3B39] block">{r.author}</span>
                <span className="text-[10px] uppercase tracking-widest text-[#C5A880] mt-1 block">{r.note}</span>
              </figcaption>
            </figure>
          ))}
        </div>

        <a
          href={MAPS_LISTING}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="see-all-google-reviews-link"
          className="inline-block mt-10 text-xs uppercase tracking-[0.2em] font-semibold text-[#0B3B39] border-b border-[#C5A880] pb-1 hover:text-[#C5A880] transition-colors duration-300"
        >
          See all reviews on Google &rarr;
        </a>
      </div>
    </section>
  );
};
